export default __webpack_public_path__ + "resources/icons/d240-9fa0.png";